(function () {
  'use strict';

  var storageKey = 'kidobook_wishlist';

  function readWishlist() {
    try {
      var value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      /* Storage can be unavailable in private mode; the UI remains usable. */
    }
  }

  function refreshWishlistButtons(scope) {
    var items = readWishlist();
    (scope || document).querySelectorAll('[data-wishlist-handle]').forEach(function (button) {
      var active = items.some(function (item) { return item.handle === button.dataset.wishlistHandle; });
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function refreshWishlistCounts() {
    var count = readWishlist().length;
    document.querySelectorAll('.kt-saved-count').forEach(function (element) {
      element.textContent = count.toLocaleString(document.documentElement.lang || 'en-US');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-handle]');
    if (!button) return;

    var items = readWishlist();
    var handle = button.dataset.wishlistHandle;
    var index = items.findIndex(function (item) { return item.handle === handle; });

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push({
        handle: handle,
        title: button.dataset.wishlistTitle || '',
        url: button.dataset.wishlistUrl || ''
      });
    }

    writeWishlist(items);
    refreshWishlistButtons(document);
    refreshWishlistCounts();
    document.dispatchEvent(new CustomEvent('kidobook:wishlist-change', { detail: { items: items } }));
  });

  function boot(event) {
    refreshWishlistButtons(event && event.target ? event.target : document);
    refreshWishlistCounts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('storage', refreshWishlistCounts);
})();
